"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUrl = void 0;
const URL_RE = /^https?:\/\/.+/;
function isUrl(url) {
    return URL_RE.test(url);
}
exports.isUrl = isUrl;
